export const environment = {
    production: true,
    defaultYear: '2024',
    siteName: 'DevFestMN',
    // This year's archive lives on its own subdomain so it never competes with the current site.
    siteUrl: 'https://2024.devfest.mn',
    firebaseConfig: {
        apiKey: 'AIzaSyBrWJx91j512T3q6AaTGNxu_3fq47bYhfg',
        authDomain: 'devfestmn.firebaseapp.com',
        databaseURL: 'https://devfestmn.firebaseio.com',
        projectId: 'firebase-devfestmn',
        storageBucket: 'firebase-devfestmn.appspot.com',
        messagingSenderId: '27347020178',
    },
    showRegister: 'https://www.eventbrite.com/e/1082249821349?aff=oddtdtcreator',
    showSchedule: true,
    showSpeakers: true,
};
